import { Button } from 'antd';
import { doc } from 'firebase/firestore';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDocumentData, useDocumentDataOnce } from 'react-firebase-hooks/firestore';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Input, Label } from '../../../components/UI/Forms/Forms';
import PencilIcon from '../../../components/UI/Icon-SVG/PencilIcon';
import ProfileIcon from '../../../components/UI/Icon-SVG/ProfileIcon';
import { Context } from '../../../index';

import AvatarUpload from './components/AvatarUpload';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  background-color: white;
  flex: 1;
  overflow: auto;
  padding-bottom: 24px;

  .article {
    font-family: Open Sans, sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    margin: 0;
  }

  .article-shadow {
    font-family: Open Sans, sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #a6b0cf;
    margin-top: 6px;
  }
`;

const View = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  max-width: 520px;
`;

const AvatarBlock = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: #c6dbff;
  position: relative;
  margin-top: 10px;

  .avatar__none {
    position: absolute;
    top: 26%;
    left: 25%;
  }

  img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-size: cover;
  }

  .edit {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #397ef3;

    div {
      margin: 2px 0 0 6px;
    }
  }
`;

const NameBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;
`;

const ContactBlock = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;
`;

const LawyerInfo = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
`;

const SmallInput = styled.div`
  width: 48%;
  margin-top: 15px;
  max-width: 254px;
`;

const LargeInput = styled.div`
  width: 100%;
  margin-top: 15px;
`;

const TextArea = styled.textarea`
  display: block;
  outline: none;
  border-top: none;
  border-right: none;
  border-left: none;
  font-size: 16px;
  border-bottom: 1px solid #397cf3;
  padding: 10px 0;
  color: black;
  width: 100%;
`;

const Gallery = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`;

const AddPhoto = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #397ef3;
  width: 88px;
  height: 88px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 18px;
  margin-bottom: 18px;

  span {
    color: #397ef3;
    font-size: 12px;
    font-family: 'Open Sans', sans-serif;
  }

  svg path {
    fill: #397ef3;
  }
`;

const PhotoWrapper = styled.div`
  position: relative;
`;
const DeleteIconWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 20px;
  cursor: pointer;
`;

const DeleteIconWrapperInList = styled.div`
  position: absolute;
  top: 0px;
  right: -12px;
  cursor: pointer;
  z-index: 3;
`;

const Photo = styled.img`
  width: 88px;
  height: 88px;
  border-radius: 5px;
  margin-right: 18px;
  background: #a6b0cf;
  margin-bottom: 18px;
`;

const AdditionalData = styled.div`
  margin-top: 24px;
`;
const Сareer = styled.div`
  width: 100%;
`;
const Education = styled.div`
  width: 100%;
`;
const Publications = styled.div`
  width: 100%;
`;

const AddItem = styled.p`
  color: #397ef3;
  font-size: 16px;
  cursor: pointer;
  margin-bottom: 0;
  margin-top: 10px;
  font-family: 'Open Sans', sans-serif;
`;

const SocialBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
`;

const InputIcon = styled.div`
  position: absolute;
  left: 5px;
  top: 10px;
  z-index: 2;
`;

const SwitcherContainer = styled.div`
  width: 100px;
  margin-top: 14px;
  margin-right: 20px;
`;

const SwitcherWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  border-bottom: 1px solid #397cf3;

  p {
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    margin-right: 10px;
  }
`;

const AvatarEdit = styled.div`
  cursor: pointer;
`;

const ProfileItem = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Text = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  margin: 0;
`;

const ShadowText = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  margin: 0;
  color: #a6b0cf;
`;

const PublicationsItem = styled.a`
  color: #397ef3;
  font-size: 16px;
  margin-top: 12px;
  font-family: 'Open Sans', sans-serif;
  display: block;
`;

const Publication = styled.div`
  position: relative;
`;

const Wrapper = styled.div`
  display: block;
  background: #fff;
  overflow: auto;
`;

const BtnsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 20px;
`;

const EditProfileClient = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({});
  const { auth, firestore } = useContext(Context);
  const user = auth.currentUser;
  const userId = user?.uid;
  const ref = useRef();
  const history = useHistory();

  const [userData] = useDocumentDataOnce(doc(firestore, 'users', userId));
  const [userFullProfileData] = useDocumentDataOnce(doc(firestore, 'user_full_profile', userId));
  const [forAvatar] = useDocumentData(doc(firestore, 'user_full_profile', userId));
  const { avatar } = forAvatar ?? {};

  useEffect(() => {
    setForm({
      first_name: userData?.first_name || '',
      last_name: userData?.last_name || '',
      address: userFullProfileData?.address || '',
      position: userFullProfileData?.position || '',
      about: userFullProfileData?.about || '',
      additional_phone: userFullProfileData?.additional_phone || '',
      email: userFullProfileData?.email || '',
    });
  }, [userData, userFullProfileData]);

  const showUploadAvatarModal = () => {
    ref.current?.showModal();
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const back = () => history.goBack();

  const save = async () => {
    setIsLoading(true);
    await firestore.collection('users').doc(userId).update({
      first_name: form.first_name,
      last_name: form.last_name,
    });
    delete form.first_name;
    delete form.last_name;
    await firestore
      .collection('user_full_profile')
      .doc(userId)
      .update({
        ...form,
      });
    setIsLoading(false);
    back();
  };

  const isInvalid = !(form.first_name && form.last_name);

  return (
    <Container>
      <AvatarUpload isLawyer={false} ref={ref} />
      <View>
        <p className="article">General information</p>
        <AvatarBlock>
          {!avatar?.avatar_path ? (
            <div className="avatar__none">
              <ProfileIcon color="#397EF3" />
            </div>
          ) : (
            <img src={avatar.avatar_path} alt="Avatar" />
          )}
          <AvatarEdit className="edit" onClick={showUploadAvatarModal}>
            <PencilIcon />
          </AvatarEdit>
        </AvatarBlock>
        <NameBlock>
          <SmallInput>
            <Label>
              First Name
              <Input value={form?.first_name} onChange={handleChange} name="first_name" />
            </Label>
          </SmallInput>
          <SmallInput>
            <Label>
              Last Name
              <Input value={form?.last_name} onChange={handleChange} name="last_name" />
            </Label>
          </SmallInput>
        </NameBlock>
        <LargeInput>
          <Label>
            About
            <TextArea
              value={form?.about}
              onChange={handleChange}
              name="about"
              placeholder="Enter about you"
            >
              {form?.about}
            </TextArea>
          </Label>
        </LargeInput>
        <SmallInput>
          <Label>
            Job
            <Input
              value={form?.position}
              onChange={handleChange}
              name="position"
              placeholder="Enter your job"
            />
          </Label>
        </SmallInput>
        <SmallInput>
          <Label>
            Additional phone
            <Input
              value={form?.additional_phone}
              onChange={handleChange}
              name="additional_phone"
              placeholder="Enter your phone"
            />
          </Label>
        </SmallInput>
        <SmallInput>
          <Label>
            Email
            <Input
              value={form?.email}
              onChange={handleChange}
              name="email"
              placeholder="Enter your email"
            />
          </Label>
        </SmallInput>
        <BtnsWrapper>
          <Button onClick={back} style={{ marginRight: 10, width: 200 }}>
            Cancel
          </Button>
          <Button
            type="primary"
            disabled={isInvalid || isLoading}
            style={{ width: 200 }}
            onClick={save}
          >
            Save
          </Button>
        </BtnsWrapper>
      </View>
    </Container>
  );
};

export default EditProfileClient;
